import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Empty, Input, Modal, Row, Table } from "antd";
import {useContext, useState} from "react";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { DocumentoTecnico } from "../../../../models/Maestras/maestras.model";
import { openNotification } from "../../../../utils/Notifactions";
import {TemplateContext} from "../../../../utils/template_context";

interface IModalDocTec {
    openModal: boolean,
    setOpenModal: Function,
    documentosTecnicos: DocumentoTecnico[],
    obtenerDocumentosTecnicos: Function,
    isEdit: boolean,
    datos: DocumentoTecnico,
    setDatos: Function
}

export const ModalDocTec = ({ openModal, setOpenModal, documentosTecnicos, obtenerDocumentosTecnicos, isEdit, datos, setDatos }: IModalDocTec) => {
    const context = useContext(TemplateContext);

    const onCancel = () => {
        setOpenModal(false)
    }

    const [documentoTecnico, setDocumentoTecnico] = useState<DocumentoTecnico>({
        nombre: '',
    })

    const addDocTec = async () => {
        //console.log(documentoTecnico)
        try {
            if (documentoTecnico.nombre !== '') {
                const data = await apiMaestras.crearDocumentoTecnico(documentoTecnico);
                if(!data.ok){
                    return openNotification({
                        titulo: "Error",
                        descripcion: data.message,
                        placement: "bottomRight",
                      })
                }
                obtenerDocumentosTecnicos();
                setDocumentoTecnico({
                    nombre: ''
                })
            }
        } catch (error) {
            console.log(error)
        }
    }

    const [visible, setVisible] = useState(false);
    const [datosDocTec, setDatosDocTec] = useState<DocumentoTecnico>({
        nombre: ''
    })
    const editarDocTec = (datos: DocumentoTecnico) => {
        setDatosDocTec(datos);
        setVisible(true);
    }

    const actualizarDocTec = async () => {
        try {
            const resp = await apiMaestras.actualizarDocumentoTecnico(datosDocTec);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerDocumentosTecnicos();
            setVisible(false)
        } catch (error) {
            console.log(error);
        }
    }


    const deleteDocTec = async (datos: DocumentoTecnico) => {
        try {
            const resp = await apiMaestras.eliminarDocumentoTecnico(datos.id);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerDocumentosTecnicos();
        } catch (error) {
            console.log(error);
        }
    }

    const guardarTodo = () => {
        obtenerDocumentosTecnicos();
        setOpenModal(false);
        setDocumentoTecnico({
            nombre: '',
        })
    }

    const guardarEdicion = async () => {
        try {
            const resp = await apiMaestras.actualizarDocumentoTecnico(datos);
            if(!resp){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerDocumentosTecnicos();
            setOpenModal(false)
        } catch (error) {
            console.log(error);
        }
    }

    const columns: any = [
        {
            title: "Nombre documento",
            key: "nombre",
            dataIndex: "nombre",
            //  fixed: context.device === "md"? "left": false,
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                    <div className="controls">
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Editar
                        </div>
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Eliminar
                        </div>
                    </div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg"? "right": false,
            render: (datos: DocumentoTecnico) => (
                <div className="controls">
                    <EditOutlined onClick={() => editarDocTec(datos)} />
                    <DeleteOutlined onClick={() => deleteDocTec(datos)} />
                </div>
            )
        },
    ]

    return (
        <>
            <Modal
                title={
                    <>
                        {isEdit
                            ?
                            (
                                <div>Editar documento técnico</div>
                            )
                            :
                            (

                                <div>Crear documento técnico</div>
                            )
                        }
                    </>
                }
                visible={openModal}
                onCancel={onCancel}
                width={1000}
                footer={
                    <>
                        {isEdit
                            ?
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarEdicion}>Guardar y Finalizar</Button>
                                    </Col>
                                </Row>
                            )
                            :
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarTodo}>Cerrar</Button>
                                    </Col>
                                </Row>
                            )
                        }
                    </>
                }
            >
                {isEdit
                    ? (
                        <Row>
                            <Col span={24}>
                                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                    Nombre documento técnico
                                </span>
                                <Input value={datos.nombre} onChange={(e) => setDatos({ ...datos, nombre: e.target.value })} />
                            </Col>
                        </Row>
                    )
                    :
                    (
                        <>
                            <Row gutter={[24, 24]}>
                                <Col span={24}>
                                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                        Nombre documento técnico
                                    </span>
                                    <Input value={documentoTecnico.nombre} onChange={(e) => setDocumentoTecnico({ ...documentoTecnico, nombre: e.target.value })} />
                                </Col>
                            </Row >
                            <Row justify="end">
                                <Col>
                                    <Button className="button-azul-radius" onClick={addDocTec}>Guardar</Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div>Documentos técnicos creados</div>
                                </Col>
                                <Col>
                                    <Table
                                        dataSource={documentosTecnicos}
                                        columns={columns}
                                        locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                        style={{ borderTop: "1px solid #C4C4C4" }}
                                        size="small"
                                        bordered={false}
                                        pagination={false}
                                    />
                                </Col>
                            </Row>
                        </>
                    )
                }
            </Modal >
            {visible &&
                <Modal
                    title="Editar documento técnico"
                    visible={visible}
                    onCancel={() => setVisible(false)}
                    width={1000}
                    footer={
                        <Row justify="end" gutter={[24, 24]}>
                            <Col>
                                <Button className="button-blanco-radius" onClick={() => setVisible(false)}>Cancelar</Button>
                            </Col>
                            <Col>
                                <Button className="button-azul-radius" onClick={actualizarDocTec}>Guardar Cambios</Button>
                            </Col>
                        </Row>
                    }
                >
                    <Row>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre documento cronograma
                            </span>
                            <Input value={datosDocTec.nombre} onChange={(e) => setDatosDocTec({ ...datosDocTec, nombre: e.target.value })} />
                        </Col>
                    </Row>

                </Modal>
            }
        </>
    )
}
